import biLogger from '@wix/web-bi-logger';

export type { Logger } from '@wix/web-bi-logger/dist/src/types';
export const webBiLogger = biLogger;
